import React, { useEffect, useState } from "react";
import blogsJson from "../data/blogs.json";
import { Link, useParams } from "react-router-dom";

const BlogReccomendations = () => {
  const [recommendations, setRecommendations] = useState([]);
  const { id } = useParams(); // yeh ab handle hoga

  useEffect(() => {
    const filteredBlogs = blogsJson.filter((b) => b.handle !== id);
    const shuffledBlogs = filteredBlogs.sort(() => 0.5 - Math.random());
    setRecommendations(shuffledBlogs.slice(0, 3));
  }, [id]);

  return (
    <div className="grid grid-cols-1 gap-4 mt-8 md:grid-cols-3">
      {recommendations.map((rec) => (
        <Link to={`/blogs/${rec.handle}`} key={rec.id}>
          <div className="flex flex-col items-center p-4 transition-shadow justify-items-center routline-dashed-lg hover:shadow-lg">
            <img
              className="object-cover w-full h-40 rounded"
              src={rec.imgUrl}
              alt={rec.title}
            />
            <h3 className="pl-4 text-black">{rec.text}</h3>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default BlogReccomendations;
